export default __webpack_public_path__ + "static/media/avatarSpeach.5784a553.svg";